enum StatCategory {
  OPERATIONAL = "operational",
  FINANCIAL = "financial",
  MISC = "misc"
}

export default StatCategory;
